import MailchimpSubscribe from "react-mailchimp-subscribe"

const url = "https://wpholding.us8.list-manage.com/subscribe/post?u=5a7e78ad96eb2efbdd334c521&amp;id=3d566d88c6";

const Mailchimb1 = () => <MailchimpSubscribe url={url}/>

export default Mailchimb1;